import "./style.scss";
import * as React from "react";
import * as _ from "lodash";

export class Legend extends React.Component<any, {}> {
  renderLegendItems = () => {
    let { payload } = this.props;
    return payload.map((item: any, index: number) => (
      <div
        key={`cartesian-chart-legend-item-${index}`}
        style={{ display: "inline-block", paddingRight: 10 }}
      >
        <div className="icon-border">
          <div className="icon-inner" style={{ backgroundColor: item.color }} />
        </div>
        &nbsp;&nbsp;&nbsp;
        <span className="label">
          {!item.value ? "Undefined" : _.startCase(item.value)}
        </span>
      </div>
    ));
  };

  render() {
    return (
      <div className="cartesian-chart-legend">
        <div className="title">{_.upperCase(this.props.compareKey + "s")}</div>
        <div className="items">{this.renderLegendItems()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/CartesianChart/common/Legend/index.tsx